module.exports = "#version 300 es\n\nprecision highp float;\n\nin vec4 fs_Col;\n\nout vec4 out_Col;\n\nvoid main()\n{\n  out_Col = vec4(0.1f, 0.1f, 0.1f, 1.f);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/background-frag.glsl
// module id = 80
// module chunks = 0